import type { Block, Text } from '@ksa/model'
import { SiteProse, SiteText, hasText } from '../context.tsx'

type Props = { heading: Text; body: Text }

export function TextSection({ block }: { block: Block }) {
  const p = block.props as unknown as Props
  const boxed = block.variant === 'boxed'
  const lead = block.variant === 'lead'

  return (
    <section className="s-section">
      <div className={`s-wrap ${boxed ? '' : 's-narrow'}`}>
        <div className={boxed ? 's-card' : ''}>
          {hasText(p.heading) && (
            <h2 className="s-h2" style={{ marginBlockEnd: '1rem' }}>
              <SiteText value={p.heading} />
            </h2>
          )}
          <SiteProse value={p.body} className={lead ? 's-lead' : 's-body'} />
        </div>
      </div>
    </section>
  )
}
